// Drag-and-drop/browse uploading is handled by the Stimulus dropzone controller
// (app/javascript/controllers/dropzone_controller.js). This file only keeps the "remove the current image" behavior
// of the trash button (.edit-upload) shown over an already-attached image. The original ImageUpload library's
// drag/drop/gallery handlers were removed: no view renders their markup (.image-overlay, .image-gallery, ...)
// anymore, so their document-level drag listeners threw on every drag over an .image-upload field.

const imageUpload = (() => {
  document.addEventListener('click', editUploadClickHandler)

  // Files dropped just outside the dropzone box (but inside the field) would otherwise make the browser open them.
  const preventFileDrop = (event) => {
    if (event.target.closest && event.target.closest('.image-upload')) event.preventDefault()
  }
  document.addEventListener('dragover', preventFileDrop)
  document.addEventListener('drop', preventFileDrop)

  // Activate uploader when editing
  function editUploadClickHandler(event) {
    if (!event.target.classList.contains('edit-upload')) return false
    const attachment = event.target.hasAttribute('data-image-field-count') ? document.querySelector('#image_field_count_' + event.target.getAttribute('data-image-field-count')) : document.querySelector('.upload-attachment')
    const actions = document.querySelector('.upload-actions')
    const previous_element = attachment.previousElementSibling

    attachment.classList.add('hidden')
    if (previous_element.classList.contains('remove-image'))
      previous_element.value = true

    const element = document.getElementsByName('images_to_be_removed')
    const length = element.length
    if(length > 0)
      element[length - 1].value = element[length - 1].value + ',' + event.target.getAttribute('data-attachment-id')
    actions.classList.remove('hidden')
  }
})()
